function getCaxaPort() {
  const port = sessionStorage.getItem("caxa-port");
  if (!port) {
    throw new Error("caxa\u73AF\u5883\u83B7\u53D6webSocket\u7684port\u5931\u8D25\uFF0Ccaxa\u5165\u53E3\u9875\u9762\u9700\u8981\u8C03\u7528initCaxa\u8FDB\u884C\u521D\u59CB\u5316\u3002");
  }
  return port;
}
export { getCaxaPort };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/caxa/getCaxaPort.js